import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomisedButton from "../../components/button/button";
import EmptyStyle from "../../components/emptyStyles/emptyStyle";

import { useExternalLogin } from "../../hooks/useExternalLogin";
import { isTokenExpiredOrMissing } from "../../utility/tokenUtils";

export default function ExternalRoute({ message = 'مشکلی رخ داده است' }: { message: string }) {
    const { externalLogin } = useExternalLogin();
    const url = window.location.href;

    const handleRoute = () => {
        const substrings = ['/kaman'];
        if (substrings.some(sub => url.includes(sub))) {
            const fixedUrl = url.replace(/\?(?=[^?]*$)/, "&");
            const params = new URLSearchParams(new URL(url).search);
            const provider = params.get("provider");
            const providerToken = params.get("token");
            //route from kaman

            const needsLogin = isTokenExpiredOrMissing();
            if (needsLogin) {
                externalLogin({
                    loginProvider: 'Kaman',
                    externalToken: providerToken!,
                });

            }



        }

    }
    return (
        <div className="w-full h-full flex flex-col justify-center items-center gap-20 p-20">
            <div>
                <EmptyStyle text={message} icon={<img src="/images/externalRouteError.svg" />} emphasisedWords={[]} emphasisedWordsColor="" >
                    <Typography sx={{ color: "var(--primary-text-color)" }} style={{ fontSize: ".75rem", fontWeight: 'bold' }}> متاسفانه در حال حاضر <span style={{ color: '#FF617C' }}>امکان ورود به سامانه</span> وجود ندارد!</Typography>
                </EmptyStyle>
            </div>
            <div className="w-full">

                <CustomisedButton title="تلاش مجدد" disable={false} onClick={handleRoute} type="button" />
            </div>
        </div>
    )
}
